// extracted by mini-css-extract-plugin
module.exports = {"item":"iN","dark":"iO","light":"iP","toggle":"iQ"};